import { Box, useTheme } from "@mui/material";
import { type FC, type RefObject, useEffect } from "react";
import { Routing } from "web_myplann/Infrastructure/Routing/Routing";
import { MyPlannNavigationHeader } from "web_myplann/Shared/Header/MyPlannNavigationHeader";
import { useScrolledPastTop } from "web_myplann/Shared/Hooks/useScrolledPastTop";
import { device } from "web_myplann/Utils/device";

type Props = {
	heroRef: RefObject<HTMLElement | null>;
	title: string;
};

export const InspirationDetailHeader: FC<Props> = ({ heroRef, title }) => {
	const theme = useTheme();
	const isDark = theme.palette.mode === "dark";
	const scrolledPastHero = useScrolledPastTop(heroRef, {
		root: null,
		topOffsetPx: theme.navigation.header.height,
	});

	useEffect(() => {
		device
			.setStatusBarOverlay(true, scrolledPastHero && !isDark)
			.catch(() => {});
	}, [scrolledPastHero, isDark]);

	return (
		<Box
			position="fixed"
			top={0}
			left={0}
			right={0}
			zIndex={theme.zIndex.appBar}
			pt="var(--mobile-safe-area-top, 0px)"
			bgcolor={scrolledPastHero ? theme.palette.surface.muted : "transparent"}
			sx={{ transition: "background-color 0.2s" }}
		>
			<MyPlannNavigationHeader
				title={scrolledPastHero ? title : ""}
				defaultRoute={Routing.Dashboard.path()}
				bgColor="transparent"
				iconColor={
					scrolledPastHero
						? theme.palette.grey[900]
						: theme.palette.darkmodeText.white
				}
			/>
		</Box>
	);
};
